// hooks/core/useModal.js
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { modalSlice } from "../../redux/modal-slice/modalSlice";
import { modalComponentStore} from "../../components/modal/utils/modalComponentStore";

const useModal = () => {
  const dispatch = useDispatch();

  const componentMount = useCallback((component) => {
    modalComponentStore.setMainComponent(component);
    dispatch(modalSlice.actions.openMainModal());
  }, [dispatch]);

  const closeModal = useCallback(() => {
    dispatch(modalSlice.actions.closeMainModal());
  }, [dispatch]);

  const subModalMount = useCallback((component, closeAll = false) => {

    modalComponentStore.setSubComponent(component);
    dispatch(modalSlice.actions.openSubModal({ closeAll }));
  }, [dispatch]);

  const closeSubModal = useCallback(() => {
    dispatch(modalSlice.actions.closeSubModal());
  }, [dispatch]);

  const closeAllModals = useCallback(() => {
    dispatch(modalSlice.actions.closeAllModals());
  }, [dispatch]);

  return {
    componentMount,
    subModalMount,
    closeModal,
    closeSubModal,
    closeAllModals
  };
};

export default useModal;
